// extracted by mini-css-extract-plugin
export default {"card":"kion-module__card--GmlT_","bubbleContainer":"kion-module__bubbleContainer--_a4FC"};